import { createSlice } from '@reduxjs/toolkit';
import {json} from "../../lib/appfuse-react/core/json";
import {Questionnaire} from "../../lib/appfuse-react/qnr";

const name = 'assessmentApplicationSurvey';

const initialState = {
    questionnaire: null,
    activeStep: 0
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setQuestionnaire(state, action) {
            const questionnaire =  json.toJSON(action.payload);
            state.questionnaire = questionnaire;
        },
        setActiveStep(state, action) {
            state.activeStep = action.payload;
        }
    }
});

export const { setQuestionnaire, setActiveStep } = slice.actions;

export const selectQuestionnaire = state =>  json.fromJSON(state[name].questionnaire, Questionnaire);
export const selectActiveStep= state => state[name].activeStep;

const assessmentApplicationSurveyReducer = slice.reducer;

export default assessmentApplicationSurveyReducer;